var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"box"},[_c('table-tap',{attrs:{"header":_vm.header,"data":_vm.data}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }